import React from "react";
import { SkeletonRow } from "./Skeleton";

/**
 * The generic arrangement for every screen that is "a list of rows": Feed,
 * Watchlist, league lists, chat lists, notifications, followers, search
 * results, settings sub-pages.
 *
 * This is deliberately plain — the tailored layouts are Profile, Portfolio and
 * Leaderboard only. Everything else composes primitives like this and gets
 * refined after launch if a specific screen needs it.
 *
 * Rows sit on the shared `divider` hairline so the skeleton occupies the same
 * rhythm as the real list and nothing jumps when data lands.
 */
const ListSkeleton = ({
  rows = 6,
  avatar = true,
  avatarSize = 40,
  columns = 1,
  columnWidths,
  divided = true,
  rowClassName = "py-3.5",
  className = "",
  label = "Loading",
}) => (
  // aria-busy on the region (NOT aria-hidden — that would hide the fact that
  // something is loading); the shapes inside are individually aria-hidden.
  <div aria-busy="true" aria-label={label} className={className}>
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        aria-hidden="true"
        className={`${rowClassName} ${
          divided && i !== rows - 1 ? "border-b border-divider" : ""
        }`}
      >
        <SkeletonRow
          avatar={avatar}
          avatarSize={avatarSize}
          columns={columns}
          columnWidths={columnWidths}
        />
      </div>
    ))}
  </div>
);

export default ListSkeleton;
